export default "__VITE_ASSET__ijCu7uRO__"